import { TaskKind } from "@/generated/graphql";

/**
 * Return a formatted task title based on the TaskKind.
 *
 * @param assessmentName - The name of the assessment.
 * @param taskKind - The kind of the task (Group, Individual, or Peer).
 * @return A formatted string representing the task title.
 */
export function formatTaskTitle(
  assessmentName?: string,
  taskKind?: TaskKind
): string {
  let prefix = "";
  let suffix = "";

  if (taskKind === TaskKind.Group) {
    prefix = "Group Work — ";
  } else if (taskKind === TaskKind.Individual) {
    prefix = "Individual Work — ";
  } else if (taskKind === TaskKind.Peer) {
    prefix = "Peer Evaluation — ";
  }

  if (assessmentName !== undefined) {
    suffix = assessmentName;
  }

  return `${prefix}${suffix}`;
}
